import { useLocation } from "react-router-dom";
import { useEffect } from "react";

/**
 * Custom hook to manage filter persistence based on navigation source
 * Filters are only restored when coming back from a details page
 * @param {function} onRestoreFilters - Callback to restore filters from Redux
 * @param {function} onClearFilters - Callback to clear filters
 */
export const useFilterNavigation = (onRestoreFilters, onClearFilters) => {
  const location = useLocation();

  useEffect(() => {
    // Check if we're coming back from a details page
    const isFromDetails = location.state?.fromDetails === true;

    if (isFromDetails) {
      // Restore filters from Redux
      onRestoreFilters && onRestoreFilters();
      // Clear the state so it doesn't trigger again
      // We use a timeout to ensure it doesn't interfere with the current render cycle
      const timer = setTimeout(() => {
        window.history.replaceState({}, document.title);
      }, 0);
      return () => clearTimeout(timer);
    } else {
      // Clear filters if coming from other pages (new navigation)
      onClearFilters && onClearFilters();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key]); // Only run when the navigation location actually changes
};
